var address = {};
module['exports'] = address;
address.city = require("./city");
address.street_root = require("./street_root");
address.country = require("./country");
address.postcode = require("./postcode");
address.default_country = require("./default_country");
address.building_number = require("./building_number");
address.street_name = require("./street_name");
address.street_address = require("./street_address");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/tr/address/index.js
// module id = 1900
// module chunks = 0